<template>
  <div>
    <BadgesList v-if="badges && badges.length" :isProfilePremium="isProfilePremium" :currentUserIsOwner="currentUserIsOwner" />
  </div>
</template>
<script>
import BadgesList from "./BadgesList";
import { BadgeStore } from "../../../ELYX/ELYXStore";

export default {
  name: "ProfileTabBadges",
  components: {
    BadgesList,
  },
  props: {
    isProfilePremium: Boolean,
    currentUserIsOwner: Boolean,
  },
  computed: {
    badges: () => BadgeStore.state.badges,
  },
};
</script>
